import { capitalize } from 'lodash';

import * as Models from 'contracts/models';

export function formatLicenseName(license: Models.UserInfo.License) {
    return `${capitalize(license.licenseType)} license`;
}
